import React from "react";

import "./review-score.css";

import HippoIcons from "../../../assets/groupimg.png";

import GlobalImage from "../image/image";

const ReviewScore = ({
  score = 0,
  totalReviews = 0,
  isRtl = true,
  isUser = false,
}) => {
  if (score <= 2) return null;

  const singleHippoWidth = 28;

  const visiblePercentage = (score / 10) * 100;

  const right = isRtl ? `-${((10 - score) / 2) * singleHippoWidth}px` : "0px";

  const fixedScore = score.toFixed(1);

  //   if you wnat to change ( rtl , ltr ) according to some places and screen size you can do with only css , by selecting the parent of it
  const style = {
    "--align": isRtl ? "flex-end" : "flex-start", // left is default
    "--right": right,
  };

  return (
    <div className="review-score" style={style}>
      <GlobalImage
        style={{
          clipPath: `polygon(0 0, ${visiblePercentage}% 0, ${visiblePercentage}% 100%, 0% 100%)`,
          WebkitClipPath: `polygon(0 0, ${visiblePercentage}% 0, ${visiblePercentage}% 100%, 0% 100%)`,
        }}
        src={HippoIcons}
        alt="Hippo ratings"
      />
      {!isUser && (
        <div className="review-score__score">
          {fixedScore} out of 10 based on {totalReviews}{" "}
          {totalReviews > 1 ? "reviews" : "review"}
        </div>
      )}

      {isUser && (
        <div className="review-score__score">Review score: {fixedScore}</div>
      )}

      {/* <div>
        {totalReviews} {totalReviews > 1 ? "reviews" : "review"}
      </div> */}
    </div>
  );
};

export default ReviewScore;
